import React from "react";
import "./service.scss";

const servicesData = [
  { title: "Full Mouth Rehabilitation", description: "Comprehensive treatment to restore function and aesthetics to your entire mouth." },
  { title: "Dental Implants", description: "Permanent solutions for missing teeth that look and feel like natural ones." },
  { title: "Root Canal Treatment", description: "A procedure to save a damaged tooth by removing infected pulp and sealing it." },
  { title: "Braces & Aligners", description: "Effective orthodontic options to straighten teeth and improve your smile." },
  { title: "Crown & Bridges", description: "Restorative solutions to strengthen damaged teeth and fill gaps from missing ones." },
  { title: "Dental Veneers", description: "Thin shells that enhance the appearance of teeth, providing a beautiful smile makeover." },
  { title: "Teeth Whitening", description: "Professional treatments to brighten your smile and remove stains effectively." },
  { title: "Tooth Extraction", description: "Safe removal of problematic teeth to maintain oral health and prevent further issues." },
  { title: "Dentures", description: "Custom-made removable appliances that replace missing teeth for improved function and aesthetics." },
];

const Service = () => {
  return (
    <section className="ppc-service-section" id="services">
      <div className="service-container">

        {/* HEADER */}
        <div className="ppc-service-header">
          <h2>Comprehensive Dental Solutions</h2>
          <p>
            Advanced treatments designed to restore, protect, and enhance your
            oral health.
          </p>
        </div>

        {/* SERVICES */}
        <div className="ppc-service-grid">
          {servicesData.map((service, index) => (
            <div className="ppc-service-card" key={index}>
              <div className="ppc-card-content">
                <p className="ppc-card-heading">{service.title}</p>
                <p className="ppc-card-para">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Service;
